<div class="dev-plot">
    <ng-container>
        <plotly-plot
            id=""
            class="plotly-area"
            [data]="this.plotSettings.data"
            [layout]="this.plotSettings.layout"
            [config]="this.plotSettings.config"
            [useResizeHandler]="true"
            [style]="this.plotSettings.style"
        ></plotly-plot>
    </ng-container>
</div>
